export default __webpack_public_path__ + "static/media/save-for-retirement-icon.3c76dc99.svg";